import { render } from "./VerticalGallery.vue?vue&type=template&id=339a718c&scoped=true"
import script from "./VerticalGallery.vue?vue&type=script&lang=js"
export * from "./VerticalGallery.vue?vue&type=script&lang=js"

import "./VerticalGallery.vue?vue&type=style&index=0&id=339a718c&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339a718c"]])

export default __exports__